import React, { useState, useEffect } from 'react';

import { Card, Grid } from '@mui/material';
import { TCSelect } from 'components/TopCourtComponents/Input/TopCourtInput';
import { getCategories } from 'services/categoryServices';

import { IconTrash, IconArrowBackUp } from "@tabler/icons"
import { orderTypeOption } from 'constant/constant';

function AssignmentComponent({
    data,
    index,
    saveAssignment,
    formId,
    deleteAssignment,
    isDefault,
    merchantId
}) {
    const [orderType, setOrderType] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);

    const [assignmentForm, setAssignmentForm] = useState({
        orderType: data.orderType,
        orderTypeSelected: data.orderTypeSelected,
        categoryId: data.categoryId,
        categorySelected: data.categorySelected,
        isDeleted: false,
        ...data,
    });

    const loadOrderType = () => {
        let orderType = [];
        for (let i = 0; i < orderTypeOption.length; i++) {
            orderType.push({
                label: orderTypeOption[i].label,
                value: orderTypeOption[i].value,
            });
        }
        setOrderType(orderType);
    }

    const onChange = (e) => {
        setAssignmentForm(prev => ({
            ...prev,
            ...e,
        }));
    };

    const getServiceCategory = async (e) => {
        setAssignmentForm((prev) => ({
            ...prev,
            categoryId: '',
            categorySelected: '',
            categoryId: ''
        }));
        if (e.orderType === 'service' || e.orderType == "add_on") {
            try {
                let { data, error } = await getCategories({
                    merchantId
                });
                if (error) throw error;
                if (data) {
                    setCategoryOptions(
                        data.map((item) => ({
                            label: item.name,
                            value: item._id,
                        }))
                    );
                }
            } catch (error) {
                console.log(error);
            }
        } else {
            setCategoryOptions([]);
        }

        setAssignmentForm((prev) => ({
            ...prev,
            ...e,
        }));
    };

    const updateAssignment = async () => {
        let courtList = assignmentForm.isDeleted
        if (courtList) {
            courtList = false
        } else {
            courtList = true
        }
        setAssignmentForm(prev => ({
            ...prev,
            isDeleted: courtList
        }))
    }

    useEffect(() => {
        loadOrderType();
    }, []);

    useEffect(() => {
        saveAssignment(assignmentForm, index);
    }, [assignmentForm])

    return (
        <Card sx={{
            mt: 1,
            boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;",
            padding: "10px 5px",
        }}>
            <Grid container xs={12} style={{
                opacity: assignmentForm.isDeleted ? 0.5 : 1,
                transition: 'opacity 0.5s ease-in-out',
                display: 'flex',
                alignItems: 'center',
                gap: 1
            }}>
                <Grid xs sx={{ p: 1 }}>
                    <TCSelect
                        label={"Order Type*"}
                        value={assignmentForm.orderTypeSelected}
                        options={orderType}
                        inDialog
                        onChange={(e) => {
                            onChange({ orderTypeSelected: e, orderType: e.value });
                            getServiceCategory({ orderTypeSelected: e, orderType: e.value });
                        }}
                        disabled={isDefault}
                    />
                </Grid>
                <Grid xs sx={{ p: 1 }}>
                    <TCSelect
                        label={"Category*"}
                        value={assignmentForm.categorySelected}
                        options={categoryOptions}
                        inDialog
                        onChange={(e) => {
                            onChange({ categorySelected: e, categoryId: e.value });
                        }}
                        disabled={assignmentForm.orderType !== 'service' && assignmentForm.orderType !== 'add_on' || isDefault}
                        showAlert={(assignmentForm.orderType !== 'service' && assignmentForm.orderType !== 'add_on') ? false : assignmentForm.categoryId === ''}
                    />
                </Grid>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    marginTop: 10,
                    padding: 8,
                }}>
                    {
                        (assignmentForm.isDeleted) ?
                            <IconArrowBackUp style={{
                                cursor: 'pointer',
                                color: '#4caf50'
                            }} onClick={() => {
                                updateAssignment()
                            }} />
                            :
                            <IconTrash style={{
                                cursor: 'pointer',
                                color: 'red'
                            }} onClick={() => {
                                if (formId) {
                                    updateAssignment()
                                } else {
                                    deleteAssignment(data._id)
                                }
                            }} />
                    }
                </div>
            </ Grid>
        </Card>
    );
}

function getOptionObject({ value, options }) {
    let selectedValue = null;
    for (let i = 0; i < options.length; i++) {
        if (options[i].value === value) {
            selectedValue = options[i];
            break;
        }
    }
    return selectedValue;
};

export default AssignmentComponent;